module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', [_c('div', {
    staticClass: "overflow-auto"
  }, [_c('div', {
    staticClass: "flex justify-between my-2"
  }, [_c('div', {
    staticClass: "flex text-center"
  }, [_c('div', {
    staticClass: "font-bold bg-theme-1 text-white text-bold rounded text-md mx-auto w-76 p-2"
  }, [_vm._v(_vm._s(_vm.start_date) + " a " + _vm._s(_vm.end_date))])]), _vm._v(" "), _c('router-link', {
    staticClass: "w-50",
    attrs: {
      "to": '/admin/reports'
    }
  }, [_c('button', {
    staticClass: "button button--sm w-32 flex items-center justify-center bg-theme-1 text-white zoom-in"
  }, [_c('app-icon', {
    attrs: {
      "name": 'chart',
      "classname": 'w-4 h-4 mr-2'
    }
  }), _vm._v("\n                    Reporte\n                ")], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('div', {
    staticClass: "flex w-1/2"
  }, [_c('div', {
    staticClass: "w-2/4 flex gap-2"
  }, [_c('p', {
    staticClass: "py-2 pt-2 w-20"
  }, [_vm._v("Ordenar por:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.order_select),
      expression: "order_select"
    }],
    staticClass: "input w-full border flex-1",
    attrs: {
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.order_select = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.changeOrder($event)
      }]
    }
  }, [_vm._l((_vm.orders), function(item) {
    return [_c('option', {
      domProps: {
        "value": item.id
      }
    }, [_vm._v("\n                            " + _vm._s(item.name) + "\n                            ")])]
  })], 2)])]), _vm._v(" "), ([1, 2, 3, 9].includes(_vm.user.team_id)) ? _c('div', {
    staticClass: "flex w-1/2"
  }, [_c('div', {
    staticClass: "w-2/4 flex gap-2"
  }, [_c('div', {
    staticClass: "py-2 pt-2 w-20"
  }, [_vm._v("Filtrar por:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.group),
      expression: "filter.group"
    }],
    staticClass: "input w-full border flex-1",
    attrs: {
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filter, "group", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.changeGroup($event)
      }]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "selected": ""
    }
  }, [_vm._v("Seleccione la cuenta")]), _vm._v(" "), _vm._l((_vm.groups), function(group) {
    return _c('option', {
      key: group.id,
      domProps: {
        "value": group.id
      }
    }, [_vm._v("\n                                " + _vm._s(group.name) + "\n                            ")])
  })], 2)])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "flex py-4 gap-2"
  }, [_c('div', {
    staticClass: "w-1/3 text-center bg-white shadow-lg p-2 rounded-lg"
  }, [_vm._v("\n                    Total Horas: "), _c('b', [_vm._v(_vm._s(_vm.total_hours))])]), _vm._v(" "), _c('div', {
    staticClass: "w-1/3 text-center bg-white shadow-lg p-2 rounded-lg"
  }, [_vm._v("\n                    Total Horas Usadas: "), _c('b', [_vm._v(_vm._s(_vm.total_hours_used.toFixed(2)))])]), _vm._v(" "), _c('div', {
    staticClass: "w-1/3 text-center bg-white shadow-lg p-2 rounded-lg"
  }, [_vm._v("\n                    Horas Disponibles: "), _c('b', [_vm._v(_vm._s(parseFloat(_vm.total_hours - _vm.total_hours_used).toFixed(2)))])])]), _vm._v(" "), _c('table', {
    staticClass: "table table-report -mt-2"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.tasks), function(task) {
    return _c('tr', {
      staticClass: "intro-x"
    }, [_c('td', [_c('div', {
      staticClass: "font-medium whitespace-no-wrap"
    }, [_c('b', {
      class: [
        task.hours > 1 ?
        'text-theme-1' :
        '' ]
    }, [_vm._v(_vm._s(task.name))])])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "text-center text-gray-600 text-xs whitespace-no-wrap"
    }, [_vm._v(_vm._s(task.group))])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "text-center text-gray-600 text-xs whitespace-no-wrap"
    }, [_vm._v(_vm._s(task.hours))])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "text-center text-gray-600 text-xs whitespace-no-wrap"
    }, [_vm._v(_vm._s(task.hours_used))])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "w-full h-4 bg-gray-400 rounded"
    }, [(task.percentage > 100) ? _c('div', {
      staticClass: "h-full rounded text-center text-xs text-white bg-theme-6",
      style: ({
        width: '100%'
      })
    }, [_vm._v(_vm._s(task.percentage) + "%")]) : _c('div', {
      staticClass: "h-full rounded text-center text-xs text-white bg-theme-1",
      style: ({
        width: task.percentage > 0 ? task.percentage + '%' : '0px'
      })
    }, [_vm._v(_vm._s(task.percentage) + "%")])])])])
  }), 0)])])]) : _c('app-loading')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "whitespace-no-wrap"
  }, [_vm._v("CUENTA - PROYECTO")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("GRUPO")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("HORAS")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("USADAS")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("PORCENTAJE")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cc98e1de","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/task/TaskHoursMonth.vue
// module id = 476
// module chunks = 1